import createIcon from '../../createIcon';

/**
 * @component @name InsertDriveFile
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiAyQzQuOSAyIDQuMDEgMi45IDQuMDEgNEw0IDIwQzQgMjEuMSA0Ljg5IDIyIDUuOTkgMjJIMThDMTkuMSAyMiAyMCAyMS4xIDIwIDIwVjhMMTQgMkg2Wk0xMyA5VjMuNUwxOC41IDlIMTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const InsertDriveFile = createIcon('InsertDriveFile', [
  [
    'path',
    {
      d: 'M6 2C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2H6ZM13 9V3.5L18.5 9H13Z',
      key: 'm0j1ei',
    },
  ],
]);

export default InsertDriveFile;
